import React from "react";
import UserDetailsHeader from "../../UserDetailsHeader";
import { Typography } from "@mui/material";
import romInfoImg from "../../../../assets/images/romInfo.png";
import "./romInfoscreen.scss";
import viewReportIcon from "../../../../assets/images/viewReport.svg";
import forwardArrow from "../../../../assets/images/forwardArrow.svg";
import { getParams, searchParams } from "../../../../utlis/helpers";
import { useNavigate } from "react-router-dom";
import { ROM_LEFT_FLEXION } from "../../../../routes/routerPath";
import { pageLocale } from "../../../../utlis/locale";

const ROMInfoScreen = () => {
  const storedTest = JSON.parse(sessionStorage.getItem("testMModule"));
  const getTestDetails = storedTest.find((e) => e.moduleId === 5);
  const { accessToken, providerId, adminId, clientId } = getParams();
  const { view_report } = pageLocale("testinfo");
  const viewReportHandler = () => {
    window.location.href = `${getTestDetails?.reportURL}&isWebsite=true&accessToken=${accessToken}&providerId=${providerId}&adminId=${adminId}&clientId=${clientId}`;
  };
  const getInfo = JSON.parse(sessionStorage.getItem("testDescription"));
  const navigate = useNavigate();
  const { flexion, extension, proceed_to_test } = pageLocale("rom");
  return (
    <UserDetailsHeader removeReportId={true}>
      <div className="rom-details-screen">
        <Typography className="title">{getInfo?.moduleName}</Typography>
        <div className="rom-info-block">
          <div className="rom-details-content">
            <img src={romInfoImg} alt="rom-leftFlexion" className="test-img" />
            <div className="rom-test-name">
              <Typography>1: {flexion}</Typography>
              <Typography>2: {extension}</Typography>
            </div>
            <Typography className="desc">{getInfo?.description}</Typography>
            {getTestDetails?.isReportAvailable && (
              <div className="item-wrapper" onClick={() => viewReportHandler()}>
                <div className="item-name">
                  <img src={viewReportIcon} alt="info" className="img" />
                  <Typography>{view_report}</Typography>
                </div>
                <div className="arrow">
                  <img src={forwardArrow} alt="forwardArrow" />
                </div>
              </div>
            )}
            <div className="proceed-btn-wrap">
              <button
                className="btn"
                onClick={() => navigate(ROM_LEFT_FLEXION + `${searchParams}`)}
              >
                {proceed_to_test}
              </button>
            </div>
          </div>
        </div>
      </div>
    </UserDetailsHeader>
  );
};

export default ROMInfoScreen;
